import { httpServiceClient } from '@/infra/http'
import { makeApiUrl } from '@/main/factories/http/api-url-factory'

import {
  LearningPreferencesApiData,
  LearningPreferencesModel,
  LearningPreferencesPatchParams
} from './learning-preferences-service-types'
import {
  buildLearningPreferencesPatchBody,
  parseLearningPreferences
} from './learning-preferences-service-utils'

export type {
  LearningPreferencesApiData,
  LearningPreferencesModel,
  LearningPreferencesPatchParams
} from './learning-preferences-service-types'
export {
  EMPTY_LEARNING_PREFERENCES,
  LEARNING_PREFERENCES_QUERY_KEY,
  MAX_CONTENT_FORMATS,
  PreferredClassType,
  WEEKLY_DEDICATION
} from './learning-preferences-service-types'

const getLearningPreferencesUrl = () => makeApiUrl('/v2/user/account/learning-preferences')

export const createLearningPreferencesService = (client = httpServiceClient) => ({
  async fetch(): Promise<LearningPreferencesModel> {
    const response = await client<LearningPreferencesApiData>({
      method: 'get',
      url: getLearningPreferencesUrl()
    })

    return parseLearningPreferences(response?.body?.data)
  },

  /**
   * PATCH parcial — só os campos presentes em `params` chegam ao backend.
   *
   * Sem `bodyNamingStrategy`: o `axios-http-client` decameliza o corpo por padrão,
   * então o objeto camelCase daqui sai como snake_case no fio, que é o formato
   * do contrato acordado. Mudar isso exigiria passar `NamingStrategy.camelCase`.
   */
  async update(params: LearningPreferencesPatchParams): Promise<void> {
    await client({
      method: 'patch',
      url: getLearningPreferencesUrl(),
      body: buildLearningPreferencesPatchBody(params)
    })
  }
})

export const learningPreferencesService = createLearningPreferencesService()
